import posthog from "posthog-js";

const POSTHOG_KEY = process.env.GATSBY_POSTHOG_KEY;
const POSTHOG_HOST = process.env.GATSBY_POSTHOG_HOST || "https://us.i.posthog.com";

// No-ops until GATSBY_POSTHOG_KEY is set (Netlify env + local .env.development/.env.production),
// so the site works identically before the PostHog project exists.
export const initPosthog = (): void => {
  if (!POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: "2026-05-30",
    capture_pageview: false,
    person_profiles: "identified_only",
  });
};

// Gatsby's client-side router doesn't touch the real browser history the way
// posthog's own autocapture pageview listener expects, so pageviews are
// captured manually from gatsby-browser's onRouteUpdate instead.
export const capturePageview = (pathname: string): void => {
  if (!POSTHOG_KEY) return;
  posthog.capture("$pageview", { $current_url: pathname });
};

// posthog attaches $pathname/$current_url to every event automatically
// (computed live at capture time), so callers only need to describe *where
// on the page* the click happened — which page it happened on is free.
export const trackEvent = (event: string, properties?: Record<string, unknown>): void => {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
};
